import { render, staticRenderFns } from "./AnnualReport2023.vue?vue&type=template&id=2a356886&scoped=true"
import script from "./AnnualReport2023.vue?vue&type=script&lang=ts"
export * from "./AnnualReport2023.vue?vue&type=script&lang=ts"
import style0 from "./AnnualReport2023.vue?vue&type=style&index=0&id=2a356886&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a356886",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a356886')) {
      api.createRecord('2a356886', component.options)
    } else {
      api.reload('2a356886', component.options)
    }
    module.hot.accept("./AnnualReport2023.vue?vue&type=template&id=2a356886&scoped=true", function () {
      api.rerender('2a356886', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/error/AnnualReport2023.vue"
export default component.exports